/**
 * Inline List Component
 * Handles smooth scrolling for anchor links
 */
class InlineList extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const links = this.querySelectorAll('.list-menu__item a');

    links.forEach((link) => {
      const href = link.getAttribute('href');

      // Only handle anchor links (starting with #)
      if (href && href.startsWith('#') && href !== '#') {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          this.smoothScrollTo(href);
        });
      }
    });
  }

  smoothScrollTo(hash) {
    const targetId = hash.substring(1); // Remove the # symbol
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth',
      });
    }
  }
}

// Define the custom element
if (!customElements.get('inline-list')) {
  customElements.define('inline-list', InlineList);
}
